export const devices = [
    {
        deviceName:"iPhone SE",
        scale:0.6042857142857142
    },

    // {
    //     deviceName:"iPhone XR",
    //     scale:1
    // },

    // {
    //     deviceName:"iPhone 12 Pro",
    //     scale:1
    // },

    // {
    //     deviceName:"iPhone Pro Max",
    //     scale:1
    // },

    // {
    //     deviceName:"Pixel 7",
    //     scale:1
    // },

    // {
    //     deviceName:"Samsung Galaxy S8+",
    //     scale:1
    // },

    // {
    //     deviceName:"Samsung Galaxy S20 Ultra",
    //     scale:1
    // },

    // {
    //     deviceName:"iPad Mini",
    //     scale:1
    // },

    // {
    //     deviceName:"iPad Air",
    //     scale:1
    // },

    // {
    //     deviceName:"iPad Pro",
    //     scale:1
    // },

    // {
    //     deviceName:"Surface Pro 7",
    //     scale:1
    // },

    {
        deviceName:'Surface Duo',
        scale:0.6699999999999997
    },

    // {
    //     deviceName:"Galaxy Z Fold",
    //     scale:1
    // },

    // {
    //     deviceName:"Asus Zenbook Fold",
    //     scale:1
    // },

    // {
    //     deviceName:"Samsung Galaxy A51/71",
    //     scale:1
    // },

    {
        deviceName:"Nest Hub",
        scale:0.5799999999999996
    },

    {
        deviceName:"Nest Hub Max",
        scale:0.7899999999999998
    }
]